import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuilderComponent } from './builder.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, I18nHelperService, AlertListModule } from '@xref/ngx';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoryIconModule } from 'src/app/components/category-icon/category-icon.module';
import { QNameFieldModule } from './components/q-name-field/q-name-field.module';
import { QStatsModule } from './components/q-stats/q-stats.module';
import { QActionsModule } from './components/q-actions/q-actions.module';
import { QPlaceholderModule } from './components/q-placeholder/q-placeholder.module';
import { QuestionDeleteModule } from './components/question-delete/question-delete.module';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslateModule,
    DragDropModule,
    MatFormFieldModule,
    MatInputModule,
    CategoryIconModule,
    QNameFieldModule,
    QStatsModule,
    QActionsModule,
    QPlaceholderModule,
    QuestionDeleteModule,
    AlertListModule
  ],
  declarations: [BuilderComponent],
  providers: [
    I18nHelperService
  ]
})
export class BuilderModule {}
